import { createAsyncThunk } from '@reduxjs/toolkit'

import { RootState } from '../../app/store'
import { fetchData, postData } from '../../shared/api/api'
import { CallResponse, PostCallRequest } from './types'
import { DirectoryContact } from '../../shared/types'

export const fetchDirectory = createAsyncThunk<
  DirectoryContact[],
  void,
  { state: RootState }
>('phone/fetchDirectory', async (_, thunkAPI) => {
  const state = thunkAPI.getState()
  const { zone } = state
  const zoneId = zone?.data?.id

  if (!zoneId) {
    return thunkAPI.rejectWithValue(
      'Unable to fetch directory. Missing zoneId from state.'
    )
  }

  try {
    const response = await fetchData<DirectoryContact[]>(
      `/zones/${zoneId}/phone/directory`
    )
    return response
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.response?.data?.error ||
        error.message ||
        'Failed to fetch directory'
    )
  }
})

export const postCall = createAsyncThunk<
  CallResponse,
  PostCallRequest,
  { state: RootState }
>('phone/postCall', async (request, thunkAPI) => {
  const { number, message } = request

  const state = thunkAPI.getState()
  const { zone, user, poi, scene } = state
  const zoneId = zone?.data?.id
  const userId = user?.profile?.uid
  const sceneId = poi?.active?.data?.scene?.id || scene?.data?.id

  if (!zoneId || !userId) {
    return thunkAPI.rejectWithValue(
      'Unable to place call. Missing zoneId or userId.'
    )
  }

  const body = {
    userId,
    number,
    message,
    sceneId,
  }

  try {
    const response = await postData<CallResponse>(
      `/zones/${zoneId}/phone/call`,
      body
    )
    return response
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.response?.data?.error || error.message || 'Failed to place call'
    )
  }
})
